import type React from 'react'

import type { ModalProps } from '@/types'
import type { GtmTriggerName } from '../../../../constants/gtm'
import { PlanUpdatedLayout } from './PlanUpdatedLayout'
import { TeamSetupButton } from './TeamSetupButton'

type Props = ModalProps & {
  planId: string
  gtagId: GtmTriggerName
  onViewed: () => void
  title: string
  text: string
  buttonTitle: string
}

export const PlanUpdatedTeam: React.FC<Props> = ({
  closeButton,
  planId,
  gtagId,
  onViewed,
  title,
  text,
  buttonTitle,
}) => (
  <PlanUpdatedLayout
    closeButton={closeButton}
    planId={planId}
    gtagId={gtagId}
    onViewed={onViewed}
    title={title}
    text={text}
  >
    <TeamSetupButton title={buttonTitle} />
  </PlanUpdatedLayout>
)
